var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row my-5"},[_c('Language'),_c('v-spacer'),_c('Social')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }